import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { BuildJsonType, EnhancedAppointment } from '@bb/domain/dist/types';

const getAppointment = async (retsId: string, appointmentId: string) => {
  const config: AxiosRequestConfig = {
    url: `/external/rets/${retsId}/appointment/${appointmentId}`,
    method: 'get',
  };

  const { data } =
    await axios.request<BuildJsonType<EnhancedAppointment>>(config);

  return data;
};

export default getAppointment;
